import "./App.css";
import Home from "./Pages/homePage";
import Header from "./Header&Footer/Header";
import About from "./Pages/About";
import Skills from "./Pages/Skills";
import Projects from "./Pages/Projects";
import Contact from "./Pages/Contact";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProjectDetails from "./components/ProjectDetails";
import UpcommingDetails from "./components/upcommingDetails";
import Footer from "./Header&Footer/Footer";
import Coverletter from "./components/CoverLetter";
import Certificate from "./Pages/certificate";

function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/projectdetails/:id" element={<ProjectDetails />} />
          <Route path="/uppcomingdetails/:id" element={<UpcommingDetails />} />
          <Route path="/coverletter" element={<Coverletter />} />
          <Route
            path="/Maia-Kiknavelidze-Certificate-Digital-Institute"
            element={<Certificate />}
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
